import type { AutopilotConversationDoc, AutopilotCustomerAction } from './autopilot';

// Die Antwortart und die Zuständigkeit sind verschiedene Dinge. Auch ältere
// Freigaben mit stage=new müssen eine Absage als reine Information zeigen.
export function autopilotConversationReview(
  conversation: Pick<AutopilotConversationDoc, 'stage' | 'messages' | 'noFit'>,
) {
  const received = (conversation.messages ?? []).filter((m) => m.direction === 'received');
  const latest = [...received].sort((a, b) => (Date.parse(b.at) || 0) - (Date.parse(a.at) || 0))[0];
  const replyClass = latest?.replyClass ?? null;
  const actions: AutopilotCustomerAction[] = [];
  if (conversation.stage === 'won' || conversation.stage === 'lost')
    return { kind: conversation.stage, replyClass, actions };
  if (replyClass === 'noNeed' || replyClass === 'unsubscribed' || conversation.noFit)
    return { kind: 'information' as const, replyClass, actions };
  if (replyClass === 'later' || replyClass === 'outOfOffice')
    return { kind: 'waiting' as const, replyClass, actions };
  if (replyClass === 'referral') return { kind: 'referral' as const, replyClass, actions };
  if (conversation.stage === 'handover')
    return {
      kind: 'handover' as const,
      replyClass,
      actions: ['contacted', 'handover', 'won', 'lost'] as AutopilotCustomerAction[],
    };
  if (replyClass === 'interested' || replyClass === 'question')
    return {
      kind: 'clarify' as const,
      replyClass,
      actions: ['star', 'unstar', 'noFit'] as AutopilotCustomerAction[],
    };
  return {
    kind: 'reviewed' as const,
    replyClass,
    actions: ['new', 'clarify'].includes(conversation.stage)
      ? (['star', 'unstar', 'noFit'] as AutopilotCustomerAction[])
      : actions,
  };
}
